module.exports = __webpack_public_path__ + "static/scale-model-of-columbia-missouri-79f04a5608b143a16560df3b8451e397.png";